import { useTranslation } from "react-i18next";

import useStore from "../useStore";
import useInternalNotes from "./useInternalNotes";

const InternalNote = () => {
  const { t } = useTranslation();
  const resourceID = useStore((state) => state.resource?.id);

  // Misma fuente que los tooltips del selector de profesionales: el listado de
  // resources del team. Con una sola query para todo el sidebar, el tooltip y
  // este panel no pueden mostrar notas distintas.
  const notes = useInternalNotes(!!resourceID);

  // El hook indexa cada nota con y sin el prefijo "resources/", asi que el
  // lookup es directo — igual que en los tooltips del selector.
  const note = (resourceID && notes[resourceID]) || "";

  if (!note) return null;

  return (
    <div className="internal-note-card p-3 mt-2 font-nunito">
      <div className="internal-note-card__title fw-bold text-uppercase mb-1">
        {t("internalNote", "Nota interna")}
      </div>
      <p className="internal-note-card__text mb-0">{note}</p>
    </div>
  );
};

export default InternalNote;
